module.exports = __webpack_public_path__ + "img/ton4.b433fc20.png";